export default function SBINPageCard({
  title,
  subtitle,
  actions,
  children,
  className = "",
}) {
  return (
    <div
      className={`w-full rounded-3xl overflow-hidden border border-slate-200 bg-white shadow-xl ${className}`}
    >
      <div className="flex flex-col gap-3 bg-gradient-to-r from-rose-500 to-rose-400 px-6 py-4 md:flex-row md:items-center md:justify-between">
        <div>
          <h1 className="text-xl md:text-2xl font-semibold text-white">
            {title}
          </h1>
          {subtitle ? (
            <div className="mt-1 text-sm md:text-base text-white/80">
              {subtitle}
            </div>
          ) : null}
        </div>
        {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
      </div>
      <div className="p-6">{children}</div>
    </div>
  );
}
